
export class FileUpload {

  contentType: string;
  fileName: string;
  fileStream: any; // TODO which type?
  savePath: string;

}